export const getFileExtension = (filename) => {
  if (!filename) {
    return "";
  }
  const ext = filename?.substring(
    filename.lastIndexOf(".") + 1,
    filename.length
  );
  return ext === null ? "" : ext;
};

export const formatFileName = (name, maxBaseLen = 24) => {
  const dot = name.lastIndexOf(".");
  const ext = dot > -1 ? name.slice(dot + 1) : "";
  let base = dot > -1 ? name.slice(0, dot) : name;
  if (base.length > maxBaseLen) base = base.slice(0, maxBaseLen - 3) + "...";
  return ext ? `${base}.${ext}` : base;
};
